var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#828282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 58C58.8366 58 66 50.8366 66 42C66 33.1634 58.8366 26 50 26C41.1634 26 34 33.1634 34 42C34 50.8366 41.1634 58 50 58ZM50 58C63.1649 58 74.2077 67.0856 77.2003 79.3285M50 58C36.8351 58 25.7923 67.0856 22.7997 79.3285M77.2003 79.3285C85.0732 72.0234 90 61.587 90 50C90 27.9086 72.0914 10 50 10C27.9086 10 10 27.9086 10 50C10 61.587 14.9268 72.0234 22.7997 79.3285M77.2003 79.3285C70.063 85.9509 60.5043 90 50 90C39.4957 90 29.937 85.9509 22.7997 79.3285",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2003 79.3285C74.2078 67.0856 63.1649 58 50.0001 58C36.8352 58 25.7923 67.0856 22.7998 79.3285C29.9371 85.9509 39.4957 90 50.0001 90C60.5044 90 70.063 85.9509 77.2003 79.3285Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42C70 53.0457 61.0457 62 50 62C38.9543 62 30 53.0457 30 42C30 30.9543 38.9543 22 50 22C61.0457 22 70 30.9543 70 42Z",
    fill: "white",
    stroke: "#828282",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0002 42C66.0002 50.8366 58.8367 58 50.0002 58C41.1636 58 34.0002 50.8366 34.0002 42C34.0002 33.1634 41.1636 26 50.0002 26C58.8367 26 66.0002 33.1634 66.0002 42Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarEmpty);
export default __webpack_public_path__ + "static/media/avatar_empty.88a2b0ed.svg";
export { ForwardRef as ReactComponent };